import React from 'react'
import { Box, IconButton, Icon, Typography } from '@mui/material'

import { TimerSinceComponent } from '@front/volcanion'

const IVRCall = ({
  onHold,
  holdColor,
  pinColor,
  onEndCall,
  callerPhone,
  connectionStartTime,
  onMutateTimer
}) => (
  <Box m={1} flexShrink={0} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Icon sx={{ fontSize: 20, color: pinColor }}>{'circle'}</Icon>
      <TimerSinceComponent startTime={connectionStartTime} mutator={onMutateTimer} />
      <Box>{callerPhone}</Box>
    </Box>
    <Box>
      <IconButton aria-label="ivr" style={{ color: holdColor }} onClick={onHold} >
        <Icon>{'phone_paused'}</Icon>
      </IconButton>
    </Box>
    <Box>
      <IconButton aria-label="ivr" style={{ color: 'white' }} onClick={onEndCall} >
        <Icon>{'phone_disabled'}</Icon>
      </IconButton>
    </Box>
    <Typography variant={'h4'} sx={{ color: 'white' }}> | </Typography>
  </Box>
)

export default IVRCall
